<template lang="pug">
  div(style="height: 650px;")
    div.row
      div.col-md-12.mb-1
        span.font-weight-bolder.text-uppercase {{ $t('ui.sbo_match_info') }}
    div.row.mb-1
      div.col
        SubmitButton(
          :loading="loading"
          icon="icon-arrow-left"
          :text="$t('ui.back')"
          type="button"
          @click.native="$emit('backFromOddsLvl')"
          variant="secondary"
          size="sm"
          ).mb-1.mr-1
        SubmitButton(
          :loading="loading"
          icon="icon-reload"
          :text="$t('ui.refresh')"
          type="button"
          @click="refresh()"
          variant="info"
          size="sm"
          ).mb-1
    div.row.mb-3(v-if="item && matchInfo").animated.fadeIn
      div.col
        b-form-group(:label="$tc('ui.matches', 1)" v-if="matchInfo['match'] && matchInfo['match'].length > 0").mb-2
          table.tablex(style="width: 100%;" v-columns-resizable)
            thead
              tr
                th(width=100)
                  span {{ $t('ui.id') }}
                th(width=80)
                  span {{ $tc('ui.sports', 1) }}
                th
                  span {{ $tc("ui.leagues", 1) }}
                th(width=200)
                  span {{ $t("ui.home") }}
                th(width=200)
                  span {{ $t("ui.away") }}
                th(width=80)
                  span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                th(width=80)
                  span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                th(width=80)
                  span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                th(width=80)
                  span {{ $t("ui.sbo") }}
                th(width=80)
                  span {{ $t("ui.ibc") }}
            tbody
              tr
                td
                  span {{ item.match_id }}
                td
                  span {{ item.sport_type }}
                td
                  span(:title="item.league_name") {{ item.league_name }}
                td
                  span(:title="item.home_team") {{ item.home_team }}
                td
                  span(:title="item.away_team") {{ item.away_team }}
                td.text-uppercase
                  span {{ item.market_type }}
                td
                  span {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                td
                  span {{ item.match_time }}
                td
                  span {{ item.sbo_map }}
                td
                  span {{ item.ibc_map }}
        b-form-group(:label="$t('ui.sbo')" v-if="matchInfo['sbo'] && matchInfo['sbo'].length > 0").mb-2
          table.tablex(style="width: 100%;" v-columns-resizable)
            thead
              tr
                th(width=100)
                  span {{ $t('ui.id') }}
                th(width=80)
                  span {{ $tc('ui.sports', 1) }}
                th
                  span {{ $tc("ui.leagues", 1) }}
                th(width=200)
                  span {{ $t("ui.home") }}
                th(width=200)
                  span {{ $t("ui.away") }}
                th(width=80)
                  span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                th(width=80)
                  span(:title="$t('ui.match_date')") {{ $t("ui.short.match_date") }}
                th(width=80)
                  span(:title="$t('ui.match_time')") {{ $t("ui.short.match_time") }}
                th(width=80)
                  span(:title="$t('ui.match_link')") {{ $t("ui.linked") }}
                th(width=60)
                  span(:title="$t('ui.running_score')") {{ $t("ui.short.running_score") }}
                th(width=60)
                  span(:title="$t('ui.running_time')") {{ $t("ui.short.running_time") }}
                th(width=50)
                  span(:title="$t('ui.home_red_card')") {{ $t("ui.short.home_red_card") }}
                th(width=50)
                  span(:title="$t('ui.away_red_card')") {{ $t("ui.short.away_red_card") }}
                th(width=200)
                  span(:title="$t('ui.parent_league')") {{ $t("ui.short.parent_league") }}
                th(width=100)
                  span(:title="$t('ui.ref_id')") {{ $t("ui.ref_id") }}
            tbody
              tr(v-for="item in matchInfo['sbo']")
                td
                  span(:title="item.match_id") {{ item.match_id }}
                td
                  span(:title="item.sport_type") {{ item.sport_type }}
                td
                  span(:title="item.league_name") {{ item.league_name }}
                td
                  span(:title="item.home_team") {{ item.home_team }}
                td
                  span(:title="item.away_team") {{ item.away_team }}
                td.text-uppercase
                  span(:title="item.market_type") {{ item.market_type }}
                td
                  span(:title="$moment(item.match_date).format('YYYY-MM-DD')") {{ $moment(item.match_date).format("YYYY-MM-DD") }}
                td
                  span(:title="item.match_time") {{ item.match_time }}
                td
                  span(:title="item.match_link") {{ item.match_link }}
                td
                  span(:title="item.running_score") {{ item.running_score }}
                td
                  span(:title="item.running_time") {{ item.running_time }}
                td
                  span(:title="item.hrc") {{ item.hrc }}
                td
                  span(:title="item.arc") {{ item.arc }}
                td
                  span(:title="item.parent_league")  {{ item.parent_league }}
                td
                  span(:title="item.ref_id")  {{ item.ref_id }}
    div.row.mb-3(v-if="groups")
      div.col
        b-form-radio-group(v-model="selectedGroup" :options="groupItems" buttons button-variant="outline-secondary" size="sm" @change="resetLog" :disabled="loading")
    div.row.mb-3(v-if="selectedGroup").animated.fadeIn
      div.col
        div.row
          div.col-md-6.clusterize
            .clusterize-scroll(style="max-width: 820px;")
              table.tablex(style="width: 100%; table-layout: auto;" v-columns-resizable)
                thead
                  tr
                    th.text-center(v-for="(v, k) in details[selectedGroup][0]")
                      span(v-if="k == 'epoch_time'") DateTime
                      span(v-else) {{ k }}
                tbody.clusterize-content
                  tr(v-for="item in details[selectedGroup]")
                    td.text-uppercase.text-center
                      span
                        b-link.clickable(href="javascript:void(0);" @click="getLogs(item)" v-if="!loading") {{ item["odds_id"] }}
                        span(v-else) {{ item["odds_id"] }}
                    td.text-uppercase.text-center(v-for="(v, k) in item" v-if="k != 'odds_id'" style="min-width: 40px;")
                      span(v-if="k!='epoch_time'") {{ v }}
                      span(v-else) {{ $moment(v / 1000000).format("YYYY-MM-DD hh:mm:ss.SSS A") }}
          div(v-if="loading").col-md-6.clusterize.animated.fadeIn
            i
              div.fa.fa-spinner.fa-spin
          div(v-if="logs && !loading").col-md-6.animated.fadeIn
            div.row
              div.col-md-4
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="sboOddsTotalRow"
                  :per-page="$store.getters.pageSize"
                  v-model="currentSBOOddsPage"
                  @input="changedOddsPage($event)").mb-1
              div.col-md-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.from") }}
                  date-picker(v-model="dStartDate" :config="locale" @blur.native="refresh()")
              div.col-md-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t("ui.to") }}
                  date-picker(v-model="dEndDate" :config="locale" @blur.native="refresh()")
              div.col-md-2
                b-input-group(size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="$store.getters.pageSize" @input="changedOddsPageSize")
                  b-input(:value="sboOddsTotalRow" readonly)
            div.clusterize-scroll(style="max-height: 300px; max-width: 820px;")
              table.tablex(style="width: 100%; table-layout: auto;" v-if="logs && logs.length > 0 && !loading" v-columns-resizable)
                thead
                  tr
                    th.text-center.sticky-position(v-for="(v, k) in logs[0]")
                      span {{ k }}
                tbody.clusterize-content
                  tr(v-for="(v, k) in logs")
                    td(v-for="(i, j) in v")
                      span.text-uppercase {{ i }}
              table.tablex(style="width: 100%; table-layout: auto;" v-else)
                thead
                  tr
                    th
                      span &nbsp;
                tbody.clusterize-content
                  tr
                    td(colspan="100%").text-center
                      span {{ $t('message.no_data_available') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";

export default {
  components: {
    SubmitButton,
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      info: null,
      logs: null,
      selectedGroup: null,
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      currentSBOOddsPage: 1,
      sboOddsTotalRow: 0,
      currentOddsDetailInfo: null,
      dStartDate: null,
      dEndDate: null,
      locale: {
        format: 'YYYY-MM-DD hh:mm A',
        useCurrent: false,
        showClear: true,
        showClose: true,
      },
      matchInfo: null
    };
  },
  computed: {
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWithTime() {
      let time = '23:59';
      return this.$moment(this.today+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    yesterdayWithTime() {
      let time = '00:00';
      return this.$moment(this.yesterday+ " " + time).format('YYYY-MM-DD HH:mm');
    },
    groupItems: function() {
      if (this.groups) {
        var list = [];
        for (var prop in this.groups) {
          list.push({
            text: this.groups[prop].bet_type + " (" + this.groups[prop].ot_count + ")",
            value: this.groups[prop].bet_type
          });
        }
        return list;
      } else {
        return null;
      }
    },
    groups() {
      if (this.info) {
        return this.info["Table"];
      } else {
        return null;
      }
    },
    details() {
      if (this.info) {
        return this.info;
      } else {
        return null;
      }
    }
  },
  mounted: function() {
    this.reset();
    this.getMatchInfo(this.item);
    this.getOddsInfo(this.item);
    this.dStartDate = this.yesterdayWithTime;
    this.dEndDate = this.todayWithTime;
  },
  methods: {
    resetLog() {
      this.logs = null;
      this.currentOddsDetailInfo = null;
      this.currentSBOOddsPage = 1;
    },
    reset() {
      this.selectedGroup = null;
      this.info = null;
      this.matchInfo = null;
      this.logs = null;
      this.currentOddsDetailInfo = null;
    },
    refresh() {
      this.getMatchInfo(this.item);

      if (this.selectedGroup) {
        this.getOddsInfo(this.item);
        if (this.logs) {
          this.currentSBOOddsPage = 1;
          this.getLogs(this.currentOddsDetailInfo);
        }
      }
    },
    getOddsInfo(val) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      let url = config.sboMatchOddsInfoUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.sbo_map,
        page_id: config.accessRoles.linkedmatch
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.info = response.data.tbl_sbo_match_odds_info;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getMatchInfo(val) {
      if (!val) {
        return;
      }

      if (!val.match_id) {
        return;
      }

      if (!val.sbo_map && !val.ibc_map) {
        return;
      }

      let url = config.matchInfoUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        match_id: val.match_id,
        sbo_match_id: val.sbo_map,
        page_id: config.accessRoles.linkedmatch
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.matchInfo = response.data.tbl_match_info;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLogs(val) {
      if (!val) {
        return;
      }

      if (!val.odds_id) {
        return;
      }

      this.currentOddsDetailInfo = val;

      let url = config.sboMatchOddsLogsUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        group_id: this.selectedGroup,
        odds_id: val.odds_id,
        page_id: config.accessRoles.linkedmatch,
        page_number: this.currentSBOOddsPage,
        page_size: this.$store.getters.pageSize,
        date_from: this.dStartDate,
        date_to: this.dEndDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              this.sboOddsTotalRow = response.data.tbl_sbo_match_odds_logs["Table"].length > 0 ? response.data.tbl_sbo_match_odds_logs["Table"][0].totalrows : 0;

              if (this.feedback.success == true) {
                var n = response.data.tbl_sbo_match_odds_logs["Table"];
                var m = [];
                for (var i in n) {
                  var ep = n[i].epoch_time / 1000000;
                  n[i].timestamp = this.$moment(ep).format("YYYY-MM-DD hh:mm:ss.SSS A");
                  delete n[i].epoch_time;
                  delete n[i].row_id;
                  delete n[i].odds_id;
                  delete n[i].match_id;
                  delete n[i].ot;
                  delete n[i].totalrows;
                  m.push(n[i]);
                }
                this.logs = m;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedOddsPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentSBOOddsPage = 1;
      this.getLogs(this.currentOddsDetailInfo);
    },
    changedOddsPage: function(pageNo) {
      this.currentSBOOddsPage = pageNo;
      this.getLogs(this.currentOddsDetailInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
